export default __webpack_public_path__ + "static/media/TheHut1.2612d54f.PNG";